// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import ComponentsPage from "./pages/ComponentsPage";
import BuyPolicy from "./pages/BuyPolicy";
import GetQuote from "./pages/GetQuote";
import PaymentSuccessful from "./pages/PaymentSuccessful";
import RenewPolicy from "./pages/RenewPolicy";
import PayPremium from "./pages/PayPremium";
import RequestPolicyDocument from "./pages/RequestPolicyDocument";
import { Toaster } from "react-hot-toast";
import PaymentUnsuccessful from "./pages/PaymentUnsuccessful";
import RopResubmission from "./pages/RopResubmission";
import { useDispatch, useSelector } from 'react-redux';
import LandingPage from "./pages/LandingPage";
import TopNavbar from "./pages/TopNavbar";
import { useLocation } from 'react-router-dom';
import PolicyDocument from "./pages/PolicyDocument";
import { useEffect } from "react";
import { getAccessToken, getValidAccessToken } from "./services/oauthservice";
import { SET_PARTNER_CONFIG } from "./redux/Action/partnerConfigAction";
import { useState } from "react";
import { fetchPartnerSmsConfig } from "./helpers/commonConstant";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsloading] = useState(true)
  const { partnerDetail } = useSelector((state) => state.domainReducer);
  const normalizedPath = location.pathname.replace(/\/$/, '').toLowerCase() || '/';
  const shouldHideNavbar = normalizedPath === '/' || normalizedPath === '/motor-insurance';
  const partnerId = partnerDetail?.PARTNER_ID || sessionStorage.getItem('PARTNER_ID');

  const fetchPartnerConfigInBackground = async (currentPartnerId) => {
    try {
      if (!currentPartnerId) {
        console.warn('Skipping partner config fetch: partnerId is missing.');
        return null;
      }

      const token = await getValidAccessToken();
      const baseUrl = process.env.REACT_APP_DIC_ADMIN_API;

      const response = await fetch(`${baseUrl}/v1/motor/get/partner/partnerConfig?partner_id=${currentPartnerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'X-Current-Url': window.location.href,
        },
      }
    );

    const data = await response.json();

      if (data?.data?.length) {
        const partnerConfig = data.data[0];

      // Save in redux
      dispatch({
        type: SET_PARTNER_CONFIG,
        payload: partnerConfig,
      });

      // Also ensure PARTNER_ID is set
      if (partnerConfig.PARTNER_ID) {
        sessionStorage.setItem('PARTNER_ID', partnerConfig.PARTNER_ID);
      }

        return partnerConfig.PARTNER_ID;
    } else {
      console.warn('No config data found for partner.');
      return null;
    }
  } catch (error) {
    console.error('Error fetching partner config:', error);
    return null;
  }
};

  useEffect(() => {
    dispatch({ type: 'domain/checkDomain' });
  }, [dispatch]);

  useEffect(() => {
    if (!partnerId) return;

    const initApp = async () => {
      try {
        await getValidAccessToken();

        const resolvedPartnerId = await fetchPartnerConfigInBackground(partnerId);
        await fetchPartnerSmsConfig(resolvedPartnerId || partnerId, dispatch);
      } finally {
        setIsloading(false);
      }
    };

    initApp();
  }, [partnerId, dispatch]);



  useEffect(() => {
    const fetchToken = async () => {
      const existingToken = sessionStorage.getItem('access_token');
      if (!existingToken) {
        await getAccessToken();
      }
    };

    fetchToken();
  }, []);

  return (
    <>
      <Toaster
        position='top-center'
        reverseOrder={false}
        toastOptions={{
          style: {
            fontSize: '18px',
          },
        }}
      />
      <div className='App'>
        {!shouldHideNavbar && <TopNavbar />}
        {isLoading ? (
          <div className='app-loader' >
            <div style={{ maxWidth: '500px', width: '100%', padding: '0 16px' }}>
              <div class="progress" style={{ height: "1px" }} >
                <div class="progress-bar" role="progressbar" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>
        ) : (
        <div className='container-fluid'>
          <div className='row'>
            {/* Navigation Links */}
            {/* <nav className="d-flex mb-5">
            <Link to="/components" className="me-3">Components</Link>
            <Link to="/buy-policy" className="me-3">Buy Policy</Link>
            <Link to="/renew-policy" className="me-3">Renew Policy</Link>
            <Link to="/pay-premium" className="me-3">Pay Premium</Link>
              <Link to="/request-policy-document" className="me-3">Request Policy Document</Link>
              <Link to="/rop-resubmission">Rop Resubmission</Link>
          </nav>  */}

            {/* Routes Configuration */}
            <Routes>
                  <Route path='/' element={<LandingPage />} />
              <Route path='/components' element={<ComponentsPage />} />
                  <Route path='/buy-policy' element={<BuyPolicy />} />
                  <Route path='/renew-policy' element={<RenewPolicy />} />
                  <Route path='/pay-premium' element={<PayPremium />} />
                  <Route path='/get-quote' element={<GetQuote />} />
                  <Route path='/policy-document' element={<PolicyDocument />} />
              <Route
                    path='/payment-result'
                element={<PaymentSuccessful />}
              />
              <Route
                    path='/payment-error'
                element={<PaymentUnsuccessful />}
              />
                  {/* <Route
                    path='/request-policy-document'
                element={<RequestPolicyDocument />}
              /> */}
                  {/* <Route path='/rop-resubmission' element={<RopResubmission />} /> */}
            </Routes>
          </div>
          </div>)}
      </div>
    </>
  );
}

export default App;
